import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { selecMtmaModules, selectCurrentDevice, selectCurrentDeviceFeatures, selectCurrentDeviceInfo, selectCurrentDeviceModel, selectCurrentDeviceStatus, selectIsSupportTimers, selectNeedResync, selectPasswordRequest, selectStateDeviceByCommandId } from 'src/app/store/device/device.selector';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { selectIsImpersMode, selectIsUser, selectRoleExplainedTechnician } from 'src/app/store/user/user.selector';
import { Observable, Subscription, combineLatest, filter, interval } from 'rxjs';
import { Device } from 'src/app/model/device';
import { Site } from 'src/app/model/site';
import { DeviceFeature } from 'src/app/model/device-feature';
import { DeviceModel } from 'src/app/model/device-model';
import { EDeviceModel, isMtmacModel, isMtmacStandardModel, isMtmacUsModel, isThOneGw } from 'src/app/conf/device-models';
import { EDeviceCategory } from 'src/app/conf/device-categories';
import * as DeviceActions from 'src/app/store/device/device.actions';
import * as HomeActions from 'src/app/store/home/home.actions';
import { DeviceState, DeviceStatus } from 'src/app/model/device-status';
import { isMockEthernetGatewayId } from 'src/app/conf/mock-ethernet-gateway';
import { MtmaModule } from 'src/app/model/mtma-module';
import { MTMACSTD_MINFWVER_PHASEIII, MTMACUS_MINFWVER_PHASEIII, MtmaModuleType } from 'src/app/conf/mtma-module';
import { PasswordEditDialogComponent } from '../password-edit-dialog/password-edit.dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { MtmaCloneDialogComponent } from '../mtma-clone-dialog/mtma-clone-dialog.component';
import { DevicesTree } from 'src/app/model/device-tree';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import { environment } from 'src/environments/environment';
import { TasksPollingService } from 'src/app/services/task-polling.service';
import { ConfirmationService } from 'primeng/api';
import { DeviceInfo } from 'src/app/model/device-info';
import { compareFirmwareVersions } from 'src/app/modules/shared/utils/version-compare';
import { shouldFetchAutomFwStatus, shouldShowGwethFwUpdateModal } from 'src/app/model/autom-fw-update';
import { GwethFwUpdateDialogComponent } from '../gweth-fw-update-dialog/gweth-fw-update.dialog.component';
import { Thermo } from 'src/app/model/thermo';
import { selectCurrentDeviceThermo } from 'src/app/store/device-th/device-th.selector';

@Component({
	selector: 'app-device-tab-group',
	templateUrl: './device-tab-group.component.html',
	providers: [ConfirmationService, DialogService],
	styles: `
		:host ::ng-deep .transparent-tabView .p-tabview-panels {
			background: transparent !important;
			padding-left: 0px;
			padding-right: 0px;
		}
		:host ::ng-deep .p-accordion-header-link {
			// background-color: #FAFBFF !important;
			border: 1px solid #D5D5D5 !important;
			margin-bottom: 2px;
		}
		:host ::ng-deep .p-accordion-header-link:hover {
			background-color: var(--surface-500) !important;
		}
	`
})

export class DeviceTabGroupComponent implements OnInit, OnDestroy {
	@Input() enableBreadcump: boolean;
	device$: Observable<Device | undefined>;
	site$: Observable<Site | undefined>;
	deviceFeature$: Observable<DeviceFeature[] | undefined>;
	dataSub: Subscription | undefined;
	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;
	isUser$: Observable<boolean | undefined>;
	isUserSub: Subscription | undefined;
	isSupportTimers$: Observable<boolean | undefined>;
	isSupportTimersSub: Subscription | undefined;
	stateDeviceByCommandId$: Observable<DeviceState | undefined>
	stateDeviceByCommandIdSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	isPasswordRequest$: Observable<boolean | undefined>;
	isPasswordRequestSub: Subscription | undefined;
	isTechnician$: Observable<boolean | undefined>;
	isTechnicianSub: Subscription | undefined;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;
	mtmaModules$: Observable<MtmaModule[] | undefined>;
	mtmaModulesSub: Subscription | undefined;
	needResync$: Observable<boolean | undefined>;
	needResyncSub: Subscription | undefined;
	thermoDevices$: Observable<Thermo | undefined>;
	thermoDevicesSub: Subscription | undefined;

	currentDeviceStatus: DeviceStatus;
	activeIndex: number;
	deviceModel: DeviceModel = new DeviceModel();
	device: Device = new Device();
	deviceFeatures: DeviceFeature[] = [];
	isUser = false;
	isSupportTimers = false;
	passwordSupport: boolean;
	timersSupport: boolean;
	passwordRequest: boolean;
	isTechnician: boolean;
	isImpersMode: boolean;
	ref: DynamicDialogRef | undefined;
	private fwUpdateDialogRef: DynamicDialogRef | undefined;

	clockPresent: boolean = false; // if clock is present in the device
	clockCheckCompleted: boolean = false; // if clock check is completed 

	listOtherMtma: DevicesTree[];

	thermo: Thermo;
	mtmaModules: MtmaModule[] = [];
	needResync: boolean;

	currentStateOnline: boolean; // Per ridurre le richieste al Back-end
	currentStateConfigured: number; // Per ridurre le richieste al Back-end

	navItems = [];

	OPERATION_ID_DATE_TIME = 3;
	COMMAND_ID_DATE_TIME = 4;
	passwordCheck = false;
	timerCheck = false;
	private automFwCheckedDeviceId?: number;

	fwVersion: string;
	deviceInfo: DeviceInfo;
	deviceInfo$: Observable<DeviceInfo | undefined>;
	deviceInfoSub: Subscription | undefined;

	currentSite: Site;

	screenWidth: number;
	pollingStatusDevice0: Subscription;
	acceptButtonStyle: string;
	rejectButtonStyle: string;

	constructor(
		private store: Store<AppState>,
		private route: ActivatedRoute,
		private router: Router,
		private translate: TranslateService,
		public dialogService: DialogService,
		private taskPollingService: TasksPollingService,
		public confirmationService: ConfirmationService,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.store.dispatch(DeviceActions.resetFirmwareUpdate());
		this.passwordCheck = false;
		this.timerCheck = false;
		this.store.dispatch(DeviceActions.passwordVerifySupportReset());
		this.currentStateOnline = false; // Per ridurre le richieste al Back-end
		this.currentStateConfigured = -1; // Per ridurre le richieste al Back-end

		this.subscribeAll();
		this.onResize();

		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'Device' } }));
		}, 2000);
	}

	initSelectors(): void {
		// Store selectors
		this.mtmaModules$ = this.store.select(selecMtmaModules);
		this.device$ = this.store.select(selectCurrentDevice);
		this.site$ = this.store.select(selectCurrentSite);
		this.deviceFeature$ = this.store.select(selectCurrentDeviceFeatures);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.isUser$ = this.store.select(selectIsUser);
		this.isSupportTimers$ = this.store.select(selectIsSupportTimers);
		this.stateDeviceByCommandId$ = this.store.select(selectStateDeviceByCommandId);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.isPasswordRequest$ = this.store.select(selectPasswordRequest);
		this.isTechnician$ = this.store.select(selectRoleExplainedTechnician);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.needResync$ = this.store.select(selectNeedResync);
		this.deviceInfo$ = this.store.select(selectCurrentDeviceInfo);
		this.thermoDevices$ = this.store.select(selectCurrentDeviceThermo);
	}

	subscribeAll(): void {
		this.needResyncSub = this.needResync$.subscribe((needResync) => {
			this.needResync = needResync;
		});
		this.isPasswordRequestSub = this.isPasswordRequest$.subscribe((passwordRequest => {
			this.passwordRequest = passwordRequest;
		}));
		this.isSupportTimersSub = this.isSupportTimers$.subscribe((isSupportTimers => {
			this.isSupportTimers = isSupportTimers;
		}));
		this.isUserSub = this.isUser$.subscribe((isUser => {
			this.isUser = isUser;
		}));

		// change when arrived response from dispatch getStateDeviceByCommandId({ commandId: 4 })
		this.stateDeviceByCommandIdSub = this.stateDeviceByCommandId$.subscribe((deviceStateDateTime => {
			if (deviceStateDateTime !== undefined && deviceStateDateTime.OperationId === this.OPERATION_ID_DATE_TIME &&
				deviceStateDateTime.CommandId === this.COMMAND_ID_DATE_TIME) {
				this.clockCheckCompleted = true; // response from GET api is arrived
				// if data is present (array is not empty), clock is present
				if (deviceStateDateTime.Data !== undefined && deviceStateDateTime.Data.length > 0) {
					this.clockPresent = true;
					this.store.dispatch(DeviceActions.getDeviceTimersInfo()); // NEED TO SHOW TAB TIMERS
				} else {
					this.clockPresent = false;
				}
			}
		}));
		this.dataSub = combineLatest([
			this.device$,
			this.deviceFeature$,
			this.site$,
			this.deviceStatus$,
		])?.subscribe(([currentDevice, currentDeviceFeatures, currentSite, deviceState]) => {
			if (deviceState) {
				this.currentDeviceStatus = deviceState;
			}
			if (currentDevice && currentSite) {
				if (this.device?.Id !== undefined && this.device.Id !== currentDevice.Id) {
					this.resetClockCheck(); // reset clock check when device is changed
				}
				this.device = currentDevice;
				this.currentSite = currentSite;
				this.taskPollingService.fetchActiveTask(this.device);
				this.deviceFeatures = currentDeviceFeatures;
				this.buildBreadcrumb(currentSite.Devices);
				this.checkUpdate();
				this.checkAutomFwUpdate();
				this.listOtherMtma = currentSite.DevicesTree.Children.filter(device => isMtmacModel(device.ModelId) && device.Id !== this.device.Id);
				if (this.isAutomation() && this.isRbe24230()) {
					this.store.dispatch(DeviceActions.getAutomationsAlias());
				}
				if (isMockEthernetGatewayId(currentDevice.Id) && this.isAutomation() && !this.passwordCheck) {
					this.store.dispatch(DeviceActions.passwordVerifySupportNot());
					this.passwordCheck = true;
				}
			}

			// PASSWORD-------------------------------------------------------
			if (currentDevice !== undefined && currentSite !== undefined && deviceState !== undefined &&
				currentDeviceFeatures !== undefined && currentDeviceFeatures.length > 0) {
				const fea = currentDeviceFeatures.find(fe => fe.Name === 'password');
				if (fea !== undefined && deviceState?.Online && deviceState?.Configured === 0 && (this.isDifferentState() ||
					!this.passwordCheck)) {
					this.passwordSupport = true;
					this.passwordCheck = true;
					setTimeout(() => {
						this.store.dispatch(DeviceActions.passwordVerifySupport({ password: '' }));
					}, 2000);
				} else if (fea === undefined && deviceState?.Online && (this.isDifferentState() || !this.passwordCheck)) {
					this.store.dispatch(DeviceActions.passwordVerifySupportNot());
					this.passwordCheck = true;
				} else if (!deviceState?.Online || deviceState?.Configured !== 0 || !this.isAutomation()) {
					this.store.dispatch(DeviceActions.passwordVerifySupportNot());
					this.passwordCheck = true;
				}
			} else if (this.device !== undefined && this.device.CategoryId !== undefined && !this.isAutomation()) {
				this.store.dispatch(DeviceActions.passwordVerifySupportNot());
				this.passwordCheck = true;
			}
			// PASSWORD-------------------------------------------------------
			const fea1 = currentDeviceFeatures.find(fe => fe.Name === 'timers');
			if (fea1 !== undefined && deviceState?.Online && deviceState?.Configured === 0) {
				this.timersSupport = true;

			}
			if (currentDevice && currentSite && deviceState && deviceState.Online && deviceState.Configured === 0 && (this.isDifferentState() || !this.timerCheck)) {
				if (this.hasDateTimeState()) {
					this.store.dispatch(DeviceActions.getStateDeviceByCommandIdReset());
					this.store.dispatch(DeviceActions.getStateDeviceByCommandId({ commandId: 4 }));
					this.timerCheck = true;
				}
			}
			if (deviceState !== undefined) {
				this.currentStateOnline = deviceState.Online; // Per ridurre le richieste al Back-end
				this.currentStateConfigured = deviceState.Configured; // Per ridurre le richieste al Back-end
			}
			this.syncGwethFwUpdateModal();
		});
		this.deviceModelSub = this.deviceModel$.pipe(filter(dm => !!dm))
			.subscribe(deviceModel => {
				const newDeviceModel = this.deviceModel === undefined || deviceModel === undefined || this.deviceModel.Id !== deviceModel.Id;
				this.deviceModel = deviceModel;
				if (newDeviceModel && this.isAutomationModel()) {
					this.getHwVersion();
					if (!this.isRbe4()) {
						this.getDeviceStates0();
						this.pollingStatusDevice0 = interval(60 * 1000).subscribe(() => this.getDeviceStates0());
					}
				}
				this.checkUpdate();
			});
		this.isTechnicianSub = this.isTechnician$.subscribe((isTechnician => {
			this.isTechnician = isTechnician;
		}));
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.mtmaModulesSub = this.mtmaModules$.subscribe(mtmaModules => {
			this.mtmaModules = mtmaModules;
		});
		this.deviceInfoSub = this.deviceInfo$.pipe(filter(d => !!d))
			.subscribe(currentDeviceInfo => {
				this.deviceInfo = currentDeviceInfo;
				this.fwVersion = this.deviceInfo.FwVersion;
			}
		);
		this.thermoDevicesSub = this.thermoDevices$.subscribe(
			deviceThermo => {
				if (this.isThermoDevice()) {
					this.thermo = deviceThermo;
				} else {
					this.thermo = null;
				}
			}
		);
	}

	checkUpdate(): void {
		if (this.device === undefined || !this.device.CurrentlyOwned || this.deviceModel === undefined ||
			this.deviceModel.Id === undefined || this.currentStateConfigured !== 0) {
			return;
		}
		const isGwFirmwareDevice =
			this.deviceModel.Id === EDeviceModel.CAMEKWY_GW ||
			this.deviceModel.Id === EDeviceModel.GW4G_RADIO ||
			this.deviceModel.Id === EDeviceModel.GW4G_STANDALONE ||
			this.deviceModel.Id === EDeviceModel.GWETH ||
			shouldFetchAutomFwStatus(this.device, this.currentSite?.Devices ?? []);
		if (!isGwFirmwareDevice) {
			return;
		}
		let test = false;
		if (environment.apiUrl !== 'https://app.cameconnect.net/api') {
			test = true;
		}
		this.store.dispatch(DeviceActions.getGWFirmwareUpdate({ test }));
	}

	checkAutomFwUpdate(): void {
		if (!this.device?.Id || !this.currentSite?.Devices) {
			return;
		}
		if (this.automFwCheckedDeviceId === this.device.Id) {
			return;
		}
		this.automFwCheckedDeviceId = this.device.Id;
		if (!shouldFetchAutomFwStatus(this.device, this.currentSite.Devices)) {
			return;
		}
		this.store.dispatch(DeviceActions.getAutomFwStatus());
	}

	// reset clock check when device is changed
	private resetClockCheck(): void {
		this.clockCheckCompleted = false;
		this.clockPresent = false;
		this.timerCheck = false;
	}

	isDifferentState(): boolean {
		if (this.currentDeviceStatus === undefined) {
			return false;
		}
		if (this.currentStateOnline !== this.currentDeviceStatus.Online) {
			return true;
		}
		if (this.currentStateConfigured !== this.currentDeviceStatus.Configured) {
			return true;
		}
		return false;
	}

	buildBreadcrumb(devices: Device[]): void {
		this.navItems = [];
		if (this.device.RootId) {
			const rootDevice = devices.find(d => d.Id === this.device.RootId);
			if (rootDevice) {
				this.navItems.push({ label: rootDevice.Name, routerLink: `../${rootDevice.Id}`, disabled: !this.enableBreadcump });
			}
		}
		if (this.device.ParentId !== this.device.RootId) {
			const parentDevice = devices.find(d => d.Id === this.device.ParentId);
			if (parentDevice) {
				this.navItems.push({ label: parentDevice.Name, routerLink: `../${parentDevice.Id}`, disabled: !this.enableBreadcump });
			}
		}
	}

	ngOnDestroy(): void {
		this.closeGwethFwUpdateModal(false);
		this.mtmaModulesSub?.unsubscribe();
		this.isUserSub?.unsubscribe();
		this.dataSub?.unsubscribe();
		this.deviceModelSub?.unsubscribe();
		this.isSupportTimersSub?.unsubscribe();
		this.isPasswordRequestSub?.unsubscribe();
		this.isTechnicianSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.pollingStatusDevice0?.unsubscribe();
		this.needResyncSub?.unsubscribe();
		this.thermoDevicesSub?.unsubscribe();
	}

	selectedIndexChange(event): void {
		this.analyticsCustomPageView(event.index);
		this.store.dispatch(HomeActions.selectDeviceTab({ index: event.index }));
	}

	analyticsCustomPageView(index: number) {
		if (this.isRbe24230()) {
			switch (index) {
				case 1:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'RBEPLUS | Settings' } }));
					}, 2000);
					break;
				case 2:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'RBEPLUS | BoardUsers' } }));
					}, 2000);
					break;
				case 3:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'RBEPLUS | Access Control' } }));
					}, 2000);
					break;
				case 4:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'RBEPLUS | LogAccess' } }));
					}, 2000);
					break;
				case 5:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'RBEPLUS | Timers' } }));
					}, 2000);
					break;
				case 6:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'RBEPLUS | Import/Export' } }));
					}, 2000);
					break;
				default:
					/* setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'Device' } }));
					}, 2000); */
					break;
			}
		}
		if (this.isThermoDevice()) {
			switch (index) {
				// TH | Settings is deprecated
				case 1:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'TH | Controls' } }));
					}, 2000);
					break;
				case 2:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'TH | Stats' } }));
					}, 2000);
					break;
				default:
					/* setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'Device' } }));
					}, 2000); */
					break;
			}
		}
		// valid for MTMAEU and MTMAUS
		if (this.isMTMAConnect()) {
			switch (index) {
				case 1:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Modules' } }));
					}, 2000);
					break;
				case 2:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Contacts' } }));
					}, 2000);
					break;
				case 3:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Units' } }));
					}, 2000);
					break;
				case 4:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | DTMF' } }));
					}, 2000);
					break;
				case 5:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | RFID' } }));
					}, 2000);
					break;
				case 6:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Keypads' } }));
					}, 2000);
					break;
				case 7:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Quick&Easy' } }));
					}, 2000);
					break;
				case 8:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Access Control' } }));
					}, 2000);
					break;
				case 9:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | LogAccess' } }));
					}, 2000);
					break;
				case 10:
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | LogCalls' } }));
					}, 2000);
					break;
				case 11:
					if (this.isMtmaCurrentlyOwned() && (this.isTechnician || this.isImpersMode)) {
						setTimeout(() => {
							this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | LogDiagnostic' } }));
						}, 2000);
					} else {
						setTimeout(() => {
							this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Settings' } }));
						}, 2000);
					}
					break;
				case 12:
					if (this.isMtmaCurrentlyOwned() && (this.isTechnician || this.isImpersMode)) {
						setTimeout(() => {
							this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Settings' } }));
						}, 2000);
					} else {
						setTimeout(() => {
							this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Import/Export' } }));
						}, 2000);
					}
					break;
				case 13:
					// just in case exists LogDiagnostic
					setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'MTMA | Import/Export' } }));
					}, 2000);
					break;
				default:
					/* setTimeout(() => {
						this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'custom_page_view', params: { page_title: 'Device' } }));
					}, 2000); */
					break;
			}
		}
	}

	hasManageModule(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageContact(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageUnit(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageDtmfTone(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageTag(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageKeypad(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageMtmaPermission(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageAccessControl(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	hasManageControlAccess(): boolean {
		return this.isRbe24230() && this.device.CurrentlyOwned;
	}

	hasManageImportExport(): boolean {
		return this.currentDeviceStatus !== undefined && (this.device.CurrentlyOwned) &&
			this.includeCategories([EDeviceCategory.Automation]) &&
			!this.isIORS485();
	}

	hasManageImportExportMtma(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	isMtmaCurrentlyOwned(): boolean {
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	isOwnerAndMtma(): boolean {
		if (!this.isMTMAConnect()) {
			return true;
		}
		return this.isMTMAConnect() && this.device.CurrentlyOwned;
	}

	isThOneGw(): boolean {
		return isThOneGw(this.device.ModelId);
	}

	hasSettingsTab(): boolean {
		if (this.includeCategories([EDeviceCategory.Thermostat])) {
			return false;
		}
		return this.currentDeviceStatus !== undefined && (this.device.CurrentlyOwned || (this.isUser && this.isGateway())) &&
			!this.includeCategories([EDeviceCategory.SubGateway, EDeviceCategory.IntercomSystem]) &&
			!this.isIORS485();
	}

	hasTimers(): boolean {
		return this.currentDeviceStatus !== undefined && (this.device.CurrentlyOwned || (this.isUser && this.isGateway())) &&
			!this.includeCategories([EDeviceCategory.SubGateway, EDeviceCategory.IntercomSystem]) &&
			!this.isIORS485() && this.isSupportTimers;
	}

	canSyncDatetime(): boolean {
		return this.currentDeviceStatus?.Online && this.currentDeviceStatus?.Configured === 0 && !this.timezoneNotSet();
	}

	timezoneNotSet(): boolean {
		return !this.currentSite?.Timezone;
	}

	syncDatetime(): void {
		this.store.dispatch(DeviceActions.updateDeviceAutomationRtc());
	}

	hasBoardUsers(): boolean {
		return this.currentDeviceStatus !== undefined && this.device.CurrentlyOwned && this.checkFeature('boardUsers');
	}

	isMTMAConnect(): boolean {
		if (this.device === undefined) {
			return false;
		}
		return isMtmacModel(this.device.ModelId);
	}

	checkFeature(feature: string): boolean {
		return !!this.deviceFeatures.find(df => df.Name === feature);
	}

	includeCategories(categories: number[]): boolean {
		return categories.includes(this.device.CategoryId);
	}

	isRbe4(): boolean {
		return this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.RBE4 || this.deviceModel.Id === EDeviceModel.RBE4030 ||
			this.deviceModel.Id === EDeviceModel.RBE4230 || this.deviceModel.Id === EDeviceModel.GEN_RBE4);
	}

	isRbe24230(): boolean {
		return this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.RBE24230 || this.deviceModel.Id === EDeviceModel.RBE230 ||
			this.deviceModel.Id === EDeviceModel.RBE24 || this.deviceModel.Id === EDeviceModel.GEN_RBE24230);
	}

	isGateway(): boolean {
		return this.device.CategoryId === EDeviceCategory.Gateway;
	}

	isIORS485(): boolean {
		return this.device.ModelId === EDeviceModel.IORS485 || this.device.ModelId === EDeviceModel.GEN_IORS485;
	}

	isVirtualDevice(): boolean {
		return this.device.CategoryId === EDeviceCategory.Virtual;
	}

	isThermoDevice(): boolean {
		return this.device.CategoryId === EDeviceCategory.Thermostat && !isThOneGw(this.device.ModelId);
	}

	hasRemoteDevices(): boolean {
		return this.device.CurrentlyOwned && this.isGateway();
	}

	hasFinalUsers(): boolean {
		if (this.includeCategories([EDeviceCategory.Thermostat])) {
			return false;
		}
		return this.device.CurrentlyOwned && this.includeCategories([EDeviceCategory.Gateway]);
	}

	isThermoDeviceOrThOneGw(): boolean {
		return this.device.CategoryId === EDeviceCategory.Thermostat || isThOneGw(this.device.ModelId);
	}

	// same logic of gateway shareable button in device-button-bar.component.ts
	sharable(): boolean {
		if (this.isThermoDeviceOrThOneGw()) {
			return false;
		}
		return this.deviceModel !== undefined && this.deviceModel.Sharable !== undefined &&
			this.deviceModel.Sharable;
	}

	hasProfiles(): boolean {
		return this.includeCategories([EDeviceCategory.HomeAutomation, EDeviceCategory.AlarmSystem]);
	}

	hasNotifications(): boolean {
		return this.device.CurrentlyOwned &&
			((this.includeCategories([EDeviceCategory.Automation, EDeviceCategory.Virtual]) &&
				!this.isIORS485()));
	}

	hasNotificationsMtmaConnectOldFwVer(): boolean {
		return this.isMtmaEUNoPhaseIII() || this.isMtmaUSNoPhaseIII();
	}

	isMtmaEUNoPhaseIII(): boolean {
		const isMtmacStandard: boolean = isMtmacStandardModel(this.device?.ModelId);
		const isEUPhaseIII: boolean = compareFirmwareVersions(this.fwVersion, MTMACSTD_MINFWVER_PHASEIII) >= 0;
		return isMtmacStandard && !isEUPhaseIII;
	}

	isMtmaUSNoPhaseIII(): boolean {
		const isMtmacUs: boolean = isMtmacUsModel(this.device?.ModelId);
		const isUSPhaseIII: boolean = compareFirmwareVersions(this.fwVersion, MTMACUS_MINFWVER_PHASEIII) >= 0;
		return isMtmacUs && !isUSPhaseIII;
	}

	isMtmaDiagnosticsEnabled(): boolean {
		return this.isMtmaEUPhaseIII() || this.isMtmaUSPhaseIII();
	}

	isMtmaEUPhaseIII(): boolean {
		const isMtmacStandard: boolean = isMtmacStandardModel(this.device?.ModelId);
		const isEUPhaseIII: boolean = compareFirmwareVersions(this.fwVersion, MTMACSTD_MINFWVER_PHASEIII) >= 0;
		return isMtmacStandard && isEUPhaseIII;
	}

	isMtmaUSPhaseIII(): boolean {
		const isMtmacUs: boolean = isMtmacUsModel(this.device?.ModelId);
		const isUSPhaseIII: boolean = compareFirmwareVersions(this.fwVersion, MTMACUS_MINFWVER_PHASEIII) >= 0;
		return isMtmacUs && isUSPhaseIII;
	}

	hasDateTimeState(): boolean {
		return this.device.CurrentlyOwned &&
			this.includeCategories([EDeviceCategory.Automation]) && this.timersSupport;
	}

	hasSafetyInputs() {
		return this.checkFeature('safetyInputs');
	}

	hasAccessLog(): boolean {
		return this.isRbe24230() && this.device.CurrentlyOwned;
	}

	isManageTagEnabled(): boolean {
		const module = this.mtmaModules.filter(item => item.Type === MtmaModuleType.MTMRFID)[0];
		if (module === undefined) {
			return false;
		}
		return true;
	}

	isManageKeypadEnabled(): boolean {
		const module = this.mtmaModules.filter(item => item.Type === MtmaModuleType.MTMKB)[0];
		if (module === undefined) {
			return false;
		}
		return true;
	}

	isLoading(): boolean { // IF loading data not show tab
		return !this.passwordRequest;
	}

	isAutomation(): boolean {
		return this.category([EDeviceCategory.Automation]);
	}

	isAutomationModel(): boolean {
		return this.categoryModel([EDeviceCategory.Automation]);
	}

	category(categories: number[]): boolean {
		if (this.device === undefined) {
			return false;
		}
		return categories.includes(this.device.CategoryId);
	}
	categoryModel(categories: number[]): boolean {
		if (this.deviceModel === undefined) {
			return false;
		}
		return categories.includes(this.deviceModel.CategoryId);
	}

	editPassword(): void {
		this.store.dispatch(DeviceActions.passwordChangeReset());
		this.ref = this.dialogService.open(PasswordEditDialogComponent, {
			header: this.translate.instant('EDIT_PASSWORD'),
			width: '70vw',
			breakpoints: { '1600px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				device: this.device
			},
		});
	}

	isMTMAConnectClone(): boolean {
		return isMtmacModel(this.device.ModelId) && this.listOtherMtma !== undefined && this.listOtherMtma.length > 0;
	}

	cloneMtma(): void {
		if (this.isMTMAConnectClone()) {
			this.store.dispatch(DeviceActions.resetCloneMtmaForm());
			this.ref = this.dialogService.open(MtmaCloneDialogComponent, {
				header: this.translate.instant('CLONE_MTMAC'),
				width: '70vw',
				breakpoints: { '1600px': '98vw' },
				contentStyle: { overflow: 'auto' },
				data: {
					deviceId: this.device.Id
				},
			});
		} else {
			this.acceptButtonStyle = "p-button-danger";
			this.rejectButtonStyle = "p-button-secondary";
			this.confirmationService.confirm({
				header: this.translate.instant('WARNING_CLONE_MTMA_TITLE'),
				message: this.translate.instant('WARNING_CLONE_MTMA_TEXT'),
				rejectLabel: this.translate.instant('CLOSE'),
				icon: 'pi cm-alert',
				accept: () => { },
				reject: () => {
				}
			});
		}
	}

	getHwVersion(): void {
		this.store.dispatch(DeviceActions.getNewStateDeviceByCommandIdReset());
		this.store.dispatch(DeviceActions.getNewStateDeviceByCommandId({ commandId: 16 }));
	}

	getDeviceStates0(): void {
		this.store.dispatch(DeviceActions.getNewStateDeviceByCommandId0Reset());
		this.store.dispatch(DeviceActions.getNewStateDeviceByCommandId0());
	}

	activeIndexChange(newIndex: number) {
		this.activeIndex = newIndex; // change tab index
		this.selectedIndexChange({ index: newIndex }); // we track the changes (also for Analytics event catch)
	}

	isThermoStatusOnline(): boolean {
		if (this.thermo !== undefined && this.thermo !== null) {
			if (this.thermo.on_line !== null && this.thermo.on_line !== undefined && this.thermo.on_line === 1) {
				return true;
			}
		}
		return false;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	col6ResponsiveButtonLayout(position: string): string {
		return StandardPageLayout.col6ResponsiveButtonLayout(this.screenWidth, position);
	}

	private syncGwethFwUpdateModal(): void {
		const show = shouldShowGwethFwUpdateModal(
			this.device,
			this.currentDeviceStatus,
			this.currentSite?.Devices ?? []
		);
		if (show) {
			if (!this.fwUpdateDialogRef) {
				this.fwUpdateDialogRef = this.dialogService.open(GwethFwUpdateDialogComponent, {
					header: this.translate.instant('DEVICE_FW_UPDATE_IN_PROGRESS'),
					closable: false,
					dismissableMask: false,
					modal: true,
					width: '22rem',
				});
				this.fwUpdateDialogRef.onClose.subscribe((goToList: boolean) => {
					this.fwUpdateDialogRef = undefined;
					if (goToList) {
						this.router.navigate(['../'], { relativeTo: this.route });
					}
				});
			}
			return;
		}
		this.closeGwethFwUpdateModal(false);
	}

	private closeGwethFwUpdateModal(goToList: boolean): void {
		if (!this.fwUpdateDialogRef) {
			return;
		}
		this.fwUpdateDialogRef.close(goToList);
	}
}
